import { ProtocolCompatibility } from "@rnavoyager/contracts";

export const TASK_PROTOCOL_DIGEST = __RNAVOYAGER_TASK_PROTOCOL_DIGEST__;
export const PROTOCOL_MISMATCH_EVENT = "rnavoyager:protocol-mismatch";

const reloadMarkerKey = "rnavoyager:protocol-reload";

export function taskProtocolSearchParams(after: string | number): URLSearchParams {
  return new URLSearchParams({
    after: String(after),
    [ProtocolCompatibility.digestQueryParameter]: TASK_PROTOCOL_DIGEST,
  });
}

export function assertTaskProtocolResponse(response: Response): void {
  const actualDigest = response.headers.get(ProtocolCompatibility.digestResponseHeader);
  if (actualDigest === TASK_PROTOCOL_DIGEST) {
    window.sessionStorage.removeItem(reloadMarkerKey);
    return;
  }

  const marker = `${TASK_PROTOCOL_DIGEST}:${actualDigest ?? "missing"}`;
  if (window.sessionStorage.getItem(reloadMarkerKey) !== marker) {
    window.sessionStorage.setItem(reloadMarkerKey, marker);
    window.dispatchEvent(
      new CustomEvent(PROTOCOL_MISMATCH_EVENT, {
        detail: { expectedDigest: TASK_PROTOCOL_DIGEST, actualDigest },
      }),
    );
  }
  throw new Error("页面协议版本与服务端不一致，请刷新页面后继续");
}

export function installProtocolMismatchReload(
  target: Pick<Window, "addEventListener" | "removeEventListener">,
  reload: () => void,
): () => void {
  const listener = () => reload();
  target.addEventListener(PROTOCOL_MISMATCH_EVENT, listener);
  return () => target.removeEventListener(PROTOCOL_MISMATCH_EVENT, listener);
}
